import { Edit } from "@mui/icons-material";
import { Box, Divider } from "@mui/material";
import { useStore } from "@priolo/jon";
import ButtonIcon from "components/controls/buttons/ButtonIcon";
import FormParagraph from "components/controls/form/FormParagraph";
import RefCmp from "components/RefCmp";
import { FunctionComponent, ReactNode } from "react";
import cycleDialogSo from "stores/cycle/editDialog";
import { CropLot } from "types/CropLot";



interface Props {
    cropLot: CropLot
}

const CropLotCmp: FunctionComponent<Props> = ({
    cropLot,
}) => {

    // STORE
    useStore(cycleDialogSo)

    // HOOKs

    // HANDLER
    const handleEditClick = () => {
        cycleDialogSo.editCropLot(cropLot)
    }

    // RENDER
    const plannedYield = cropLot.plannedYield?.toFixed(1) ?? "--"
    const effectiveYield = cropLot.yield?.toFixed(1) ?? "--"
    const seedUsed = !!cropLot.seedUsedG ? Math.round(cropLot.seedUsedG) : "--"
    const gelUsed = !!cropLot.gelUsedG ? Math.round(cropLot.gelUsedG) : "--"

    return (
        <FormParagraph key={cropLot.id}
            title={cropLot.cropName}
            endRender={<Box sx={{ display: "flex", gap: "3px", alignItems: "center" }}>
                <RefCmp uuid={cropLot.lotCode} />
                <ButtonIcon
                    tooltip={"EDIT CROP LOT"}
                    onClick={handleEditClick}
                >
                    <Edit />
                </ButtonIcon>
            </Box>}
        >
            <Box sx={{ display: "flex", flexDirection: "row", gap: "10px", justifyContent: "space-between" }}>
                <ValueCmp
                    title={"SEED TROLLEYS"}
                    value={cropLot.trolleysToSeed ?? "--"}
                />
                <ValueCmp
                    title={"SEED USED"}
                    value={seedUsed}
                    um="g"
                />
                <ValueCmp
                    title={"GEL USED"}
                    value={gelUsed}
                    um="g"
                />

                <Divider orientation="vertical" flexItem />

                <ValueCmp
                    title={"CUTTING HEIGHT"}
                    value={cropLot.cutHeight ?? "--"}
                    um="mm"
                />
                <ValueCmp
                    title={"HARVEST TROLLEYS"}
                    value={cropLot.trolleysToHarvest ?? "--"}
                />
                {/* <ValueCmp
                    title="UNITS YIELD"
                    value={cropLot.unitsYield ?? "--"}
                /> */}
                <ValueCmp
                    title={"PLANNED YIELD"}
                    value={plannedYield} um="kg"
                    value2={cropLot.plannedUnitsYield} um2="units"

                />
                <ValueCmp
                    title={"YIELD"}
                    value={effectiveYield} um="kg"
                    value2={cropLot.unitsYield} um2="units"
                />
            </Box>
        </FormParagraph>
    )
}

export default CropLotCmp

interface ValueProps {
    title: string
    value: ReactNode
    um?: string
    value2?: ReactNode
    um2?: string
}

const ValueCmp: FunctionComponent<ValueProps> = ({
    title,
    value,
    um,
    value2,
    um2,
}) => (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "5px", alignItems: "flex-end" }}>
        <Box sx={{ fontSize: "12px", fontWeight: 300 }}>
            {title}
        </Box>
        <Box sx={{ fontSize: "16px", fontWeight: 500 }}>
            {value} <span style={{ fontSize: "12px", opacity: .7 }}>{um}</span>
            {value2 != null &&
                <> <span style={{ opacity: .7 }}>|</span> {value2} <span style={{ fontSize: "12px", opacity: .7 }}>{um2}</span></>
            }
        </Box>
    </Box>
)

